module.exports = __webpack_public_path__ + "img/b79524ea04093959fac62a54a619d00.7fc2ad52.png";